// extracted by mini-css-extract-plugin
export default {"mCard":"eF-z","image":"fF-z","imageNoBackground":"gF-z","imageHasCategory":"hF-z","fullWidth":"iF-z"};